import {useMutation} from '@tanstack/react-query'
import axios from 'axios'
import {useParams} from 'react-router-dom'
import {CreateGroupPayload, MessageTypeE} from '../chat.model'
import {sendChatFile, SendFilePayload} from '../services/chat.http'
import {MUTATION_KEYS} from './keys'
import {useSendGroupMessageV3} from './useSendGroupMessageV3'
import {useMe} from '@/features/authentication/queries/useMe'
import {UserRoleE} from '@/types'
import {LocalStorageManager} from '@/utilities/localStorage'

export const useSendGroupFileV3 = (onSuccess?: () => void) => {
    const {channel} = useParams()
    const groupId: string = channel?.replace('group-', '') ?? ''
    const {mutateAsync: sendGroupMessage} = useSendGroupMessageV3()
    const {data: user} = useMe()
    const isRepresentative = user?.type === UserRoleE.Representative
    const representedCreatorId = isRepresentative ? LocalStorageManager.chatUserId.get() : undefined

    return useMutation({
        mutationKey: [MUTATION_KEYS.sendGroupFileV3],
        mutationFn: async ({
            payload,
            file,
            metadata = {}
        }: {
            payload: SendFilePayload
            file: File
            metadata?: {
                morgiAmount?: number
            }
        }) => {
            const resPreLink = await sendChatFile({
                ...payload,
                ...(representedCreatorId && {representedCreatorId})
            })

            if (resPreLink.url) {
                const formData = new FormData()
                Object.entries(resPreLink.fields).forEach(([key, value]) => {
                    formData.append(key, value as string)
                })
                formData.append('file', file)

                await axios.post(resPreLink.url, formData)

                const data: CreateGroupPayload = {
                    messageType: 'media',
                    attachment: {
                        fileUploadId: resPreLink.fileUploadId
                    },
                    message: {
                        type: payload.fileType as unknown as MessageTypeE,
                        metadata
                    }
                }

                sendGroupMessage({groupId, payload: data})
            }
        },
        onSettled: () => {
            onSuccess?.()
        }
    })
}
